import { render, staticRenderFns } from "./ActiveItem.vue?vue&type=template&id=1758cf84&"
import script from "./ActiveItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ActiveItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports